<template>
    <div></div>
</template>
<script>
export default{
    created(){
        this.$router.go(-1);
    }
}
</script>